import styled from 'styled-components';

const StyledDurationTime = styled.div `
  box-sizing: border-box;
  text-align: center;
  min-width: 38px;
  height: 20px;
  padding: 3px 2px 2px;
  font-size: ${props => props.theme.typography.text.micro.fontSize};
  background: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.slate};
  font-weight: ${props => props.theme.typography.fontWeight.medium};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const StyledDurationIcon = styled.div `
  box-sizing: border-box;
  background: ${props => props.theme.colors.skyBlue};
  padding: 1px 3px 0 2px;
  border-radius: 0 0 4px;
  height: 20px;

  svg {
    width: 15px;
    height: 12px;
  }
`;

export { StyledDurationIcon, StyledDurationTime };
//# sourceMappingURL=Duration.styles.mjs.map
